import { gsap } from 'gsap';

export default class HomeHero {
	constructor(element) {
		this.element = element;

		this.heroImagesContainer = this.element.querySelector('[data-diganl-home-hero-images]');
		this.heroImages = this.element.querySelectorAll('[data-diganl-home-hero-image]');

		this.heroButton = this.element.querySelector('[data-diganl-home-hero-button]');
		this.appsOverview = document.querySelector('[data-diganl-apps-overview]');

		this.breakpoint = window.matchMedia('(min-width: 768px)');

		this.init();
	}

	init() {
		gsap.set(this.element, { position: 'relative' });
		this.placeImages();

		window.addEventListener('resize', () => this.placeImages());

		if (this.heroButton) {
			this.heroButton.addEventListener('click', (e) => {
				e.preventDefault();
				this.scrollTo();
			});
		}
	}

	placeImages() {
		if (!this.breakpoint.matches) {
			this.clearImages();
			return;
		}

		const refWidth = 1440;
		const refHeight = 1030;

		// top/left are pixel values on the reference canvas (refWidth x refHeight)
		const positions = [
			{ top: 168, right: 1117, bottom: 468, left: 144 },
			{ top: 449, right: 1224, bottom: 654, left: 72 },
			{ top: 719, right: 1008, bottom: 196, left: 216 },
			{ top: 187, right: 216, bottom: 574, left: 1080 },
			{ top: 367, right: 144, bottom: 630, left: 1152 },
			{ top: 750, right: 72, bottom: 95, left: 936 },
		];

		this.heroImages.forEach((image) => {
			const index = parseInt(image.dataset.diganlHomeHeroImage);
			const pos = positions[index];

			if (!pos) return;

			gsap.set(image, {
				position: 'absolute',
				top: `${(pos.top / refHeight) * 100}%`,
				right: `${(pos.right / refWidth) * 100}%`,
				left: `${(pos.left / refWidth) * 100}%`,
				bottom: `${(pos.bottom / refHeight) * 100}%`,
				visibility: 'visible',
			});
		});
	}

	clearImages() {
		this.heroImages.forEach((image) => {
			gsap.set(image, { clearProps: 'position,left,top,visibility' });
		});
	}

	scrollTo() {
		if (this.appsOverview) {
			this.appsOverview.scrollIntoView({
				behavior: 'smooth',
			});
		}
	}
}
